import { chooseAOrB } from 'common/helper/choose/a-or-b';

/**
 * Choose a if condition is true or null if condition is false
 */
export const chooseAOrNull =
  <A>(a: A) =>
  (condition: boolean) =>
    chooseAOrB(a, null)(condition);
